import Script from 'next/script';

type Props = {
    cid: string;
    domain: string;
};

export function UserLinkScript({ cid, domain }: Props) {
    return (
        <Script
            src="https://files.userlink.ai/public/embed.min.js"
            id="bai-scr-emb"
            charSet="utf-8"
            strategy="lazyOnload"
            data-cid={cid}
            {...{ domain }}
        />
    );
}
